import { PointCardExpiration, PointCardExpirationUnit } from '../types/pointCard'
import { format } from 'date-fns'

export const getExpiration = (expiration: PointCardExpiration | null, type: 'card' | 'offer'): string => {
  if (expiration === null) {
    return '期限なし'
  } else if (expiration.expires_at) {
    return format(expiration.expires_at.toDate(), 'yyyy年M月d日')
  } else if (expiration.expiration_unit) {
    if (type === 'card') {
      return `最終ポイント取得日から${expiration.expiration_period}${
        PointCardExpirationUnit[expiration.expiration_unit]
      }後`
    } else if (type === 'offer') {
      return `特典獲得日から${expiration.expiration_period}${PointCardExpirationUnit[expiration.expiration_unit]}後`
    } else {
      return ''
    }
  } else {
    return ''
  }
}
